import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";
import refetchCollectionQueries from "../utils/refetchCollectionQueries";

const useRemoveCollectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["collections"],
    mutationFn: (collectionId: string) =>
      collectionApiClient.deleteCollection(collectionId),
    onSuccess: () => refetchCollectionQueries(queryClient),
  });
};

export default useRemoveCollectionMutation;
